import API from '@/api';
const textReplacement = API.get('textReplacement');

export default ({
    namespaced: true,
    state: {
        text_replacements: [],
        last_page: 0,
        hint: '',
        full_text_replacement: JSON.parse(localStorage.getItem('full_text_replacement') || '{}'),
        matched_replacement: ''
    },
    getters: {
        text_replacements: state => state.text_replacements,
        full_text_replacement: state => state.full_text_replacement,
        last_page: state => state.last_page,
        hint: state => state.hint,
        matched_replacement: state => state.matched_replacement
    },
    mutations: {
        setMatchedReplacement (state, text) {
            state.matched_replacement = text;
        },
        setTextReplacements (state, data) {
            state.text_replacements = data;
        },
        setLastPage (state, page) {
            state.last_page = page;
        },
        setHint (state, text) {
            if (text != '' && text != undefined && text != null) {
                state.hint = text;
            } else {
                state.hint = '';
            }
        },
        setFullTextReplacements (state) {
            state.full_text_replacement = JSON.parse(localStorage.getItem('full_text_replacement') || '{}')
        }
    },
    actions: {
        async fetchTextReplacements (state, { per_page=null, page=null, search=null }) {
            let response = null;
            response = await textReplacement.getTextReplacements(per_page, page, search);
            state.commit('setTextReplacements', response.data.data);
            state.commit('setLastPage', response.data.last_page);
        },
        async fetchFullTextReplacements (state) {
            let response = null;
            response = await textReplacement.getTextReplacements(1000, 1, null);
            localStorage.setItem('full_text_replacement', JSON.stringify(response.data.data));
            state.commit('setFullTextReplacements');
        },
        async createTextReplacement (state, { key = null, replacement = null }) {
            return await textReplacement.createTextReplacement({ key: key, replacement: replacement });
        },
        async updateTextReplacement (state, { id = 0, key = null, replacement = null }) {
            return await textReplacement.updateTextReplacement(id, { key: key, replacement: replacement });
        },
        async deleteTextReplacement (state, {id = null}) {
            return await textReplacement.deleteTextReplacement(id);
        }
    }
})